/*
 * Glass before/after: a clean "glass" layer slides across the dusty screen as you scroll (transforms only). A bright
 * glass edge leads the sweep, the Before tag gives way to After, then the button and figures slide in.
 * Final state (clean screen) for reduced motion and without scripts.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ex-glass]');
  if (!root || !window.EluxaScroll || window.EluxaScroll.reduced()) return;

  var after = root.querySelector('.ex-gl__after');
  var afterImg = after && after.querySelector('.ex-gl__img');
  var beforeImg = root.querySelector('.ex-gl__before');
  var edge = root.querySelector('.ex-gl__edge');
  var tagB = root.querySelector('.ex-gl__tag--b');
  var tagA = root.querySelector('.ex-gl__tag--a');
  var rise = [].slice.call(root.querySelectorAll('[data-rise]'));
  if (!after || !afterImg || !beforeImg) return;

  root.classList.add('is-anim');

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  function render(p) {
    var e = ease(clamp((p - 0.08) / 0.7));
    var off = (1 - e) * 100;
    after.style.transform = 'translate3d(' + (-off).toFixed(2) + '%,0,0)';
    afterImg.style.transform = 'translate3d(' + off.toFixed(2) + '%,0,0)';
    if (edge) edge.style.opacity = e < 0.02 ? '0' : clamp((1 - e) * 12).toFixed(3);
    if (tagB) tagB.style.opacity = (1 - clamp(e * 7)).toFixed(3);
    if (tagA) tagA.style.opacity = clamp((e - 0.9) * 10).toFixed(3);
    for (var i = 0; i < rise.length; i++) {
      var l = easeOut(clamp((p - 0.78 - i * 0.07) / 0.2));
      rise[i].style.opacity = l.toFixed(3);
      rise[i].style.transform = 'translate3d(0,' + ((1 - l) * 28).toFixed(1) + 'px,0)';
    }
  }

  // The clean layer is clipped away at first, so lazy loading would not fetch it in time: load both near the section.
  var imgs = [beforeImg, afterImg];
  if ('IntersectionObserver' in window) {
    var near = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      near.disconnect();
      imgs.forEach(function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); });
    }, { rootMargin: '100% 0px' });
    near.observe(root);
  } else {
    imgs.forEach(function (im) { im.loading = 'eager'; });
  }

  window.EluxaScroll.pin(root, render);
})();
